import { render, staticRenderFns } from "./CardList.vue?vue&type=template&id=b207e602&scoped=true&"
import script from "./CardList.vue?vue&type=script&lang=js&"
export * from "./CardList.vue?vue&type=script&lang=js&"
import style0 from "./CardList.vue?vue&type=style&index=0&id=b207e602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b207e602",
  null
  
)

export default component.exports